import React from "react"
import { cn } from "../utils"

export type DrawerBodyProps = {
  children?: React.ReactNode
  className?: string
}

const bodyStyles = "flex-1 min-h-0 overflow-y-auto p-6"

/**
 * The drawer's scrollable content region.
 */
export function DrawerBody({ children, className }: DrawerBodyProps) {
  return (
    <div data-slot="drawer-body" className={cn(bodyStyles, className)}>
      {children}
    </div>
  )
}

DrawerBody.displayName = "Drawer.Body"
